import { createContext, useContext, useEffect, useState } from 'react';
import Api, { Settings } from 'axiosApi/api';
import ErrorTemplateFoundPage from 'components/common/ErrorTemplatePage';
import globalAxios, { Axios, AxiosError } from 'axios';
import { useToastMessageQueue } from 'components/ToastMessages/ToastMessageProvider';
import { fetchRemoteSettings, resolveSettings } from './settings';
const ApiContext = createContext<Api | null>(null);
const ApiDataContext = createContext<{loginUrl: string, redirectUrl: string, urlWssNotifications: string}>({loginUrl: '', redirectUrl: '', urlWssNotifications: ''});

export default function ApiProvider({ children }) {
  const [api, setApi] = useState<Api|null>(null);
  const [loginUrl, setLoginUrl] = useState<string|null>(null);
  const [redirectUrl, setRedirectUrl] = useState<string|null>(null);
  const [urlWssNotifications, setUrlWssNotifications] = useState<string|null>(null);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const remoteSettings = await fetchRemoteSettings();
        const settings = resolveSettings(remoteSettings);

        // Log the settings for debugging
        console.log('Loaded settings:', settings);
        
        const querySearchParams = new URLSearchParams({
          response_type: settings.RESPONSE_TYPE,
          client_id: settings.CLIENT_ID,
          redirect_uri: settings.REDIRECT_URL,
          state: 'STATE',
          scope: 'openid email'
        }).toString();
        
        const url = new URL('/login', settings.LOGIN_DOMAIN);
        url.search = querySearchParams;
        setLoginUrl(url.toString());
        setRedirectUrl(settings.REDIRECT_URL);
        setUrlWssNotifications(settings.URL_WSS_NOTIFICATIONS);
        setApi(new Api(settings));
      } catch (e) {
        console.error(e);
        setError(true);
      }
    };
    fetchSettings();
  }, []);
  globalAxios.interceptors.response.use((response)=>response, (error) => {
    // Handle "ERR_NETWORK" error
    const axiosError: AxiosError = error as AxiosError;
    return Promise.reject(error);
  });
  

  if(error) {
    return <ErrorTemplateFoundPage statusCode={500} title="Error" message={'Failed to load settings...'} />;
  }
  return (api &&
    <ApiContext.Provider value={api}>
      <ApiDataContext.Provider value={{loginUrl, redirectUrl, urlWssNotifications}}>
        {children}
      </ApiDataContext.Provider>
    </ApiContext.Provider>
  );
}

export function useApi() {
  return useContext(ApiContext);
}

export function useApiData() {
  return useContext(ApiDataContext);
}